import { Button, Col, Drawer, Form, Input, InputNumber, Row, Select, Space, Switch } from 'antd';
import XhsAccountCheckButton from '../XhsAccountCheckButton';

const AccountEditorDrawer = ({
  drawerMode,
  drawerVisible,
  closeDetailDrawer,
  detailLoading,
  xhsProvisioning,
  xhsProvisionAccount,
  onXhsProvisionSuccess,
  detailForm,
  platformOptions,
  onSave,
}) => (
  <Drawer
    title={drawerMode === 'create' ? '新增账号' : '编辑账号'}
    placement="right"
    width={720}
    onClose={closeDetailDrawer}
    open={drawerVisible}
    loading={detailLoading}
    mask
    maskStyle={{ backdropFilter: 'none', WebkitBackdropFilter: 'none' }}
    footer={(
      <div style={{ textAlign: 'right' }}>
        <Space>
          <Button onClick={closeDetailDrawer}>取消</Button>
          <Button type="primary" onClick={onSave} loading={detailLoading || xhsProvisioning} disabled={Boolean(xhsProvisionAccount)}>
            保存
          </Button>
        </Space>
      </div>
    )}
  >
    {drawerMode === 'create' && xhsProvisionAccount && (
      <div
        style={{
          padding: 12,
          marginBottom: 16,
          border: '1px solid #f0f0f0',
          borderRadius: 8,
          background: '#fafafa',
        }}
      >
        <div style={{ fontWeight: 600, marginBottom: 6 }}>小红书账号已创建</div>
        <div style={{ color: '#666', marginBottom: 8 }}>请在此抽屉内完成扫码登录，登录成功后将自动关闭。</div>
        <XhsAccountCheckButton
          account={xhsProvisionAccount}
          inline
          autoStart
          restartMcp
          onSuccess={onXhsProvisionSuccess}
        />
      </div>
    )}
    <Form form={detailForm} layout="vertical" style={{ padding: '8px 0' }}>
      <Row gutter={[16, 0]}>
        <Col span={12}>
          <Form.Item
            label="账号ID"
            name="account_id"
            rules={drawerMode === 'edit' ? [{ required: true, message: '缺少账号ID' }] : []}
          >
            <Input placeholder={drawerMode === 'create' ? '可选：不填则自动生成' : ''} disabled={drawerMode === 'edit'} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="平台"
            name="platform"
            rules={[{ required: true, message: '请选择平台' }]}
          >
            <Select allowClear placeholder="请选择平台" options={platformOptions} />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={[16, 0]}>
        <Col span={12}>
          <Form.Item
            label="账号名称"
            name="account_name"
            rules={[{ required: true, message: '请输入账号名称' }]}
          >
            <Input placeholder="用于展示与检索" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="账号类型" name="account_type">
            <Select
              allowClear
              placeholder="请选择账号类型"
              options={[
                { label: '个人', value: '个人' },
                { label: '机构', value: '机构' },
              ]}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={[16, 0]}>
        <Col span={12}>
          <Form.Item label="状态" name="status">
            <Select
              allowClear
              placeholder="请选择状态（默认 active）"
              options={[
                { label: '活跃', value: 'active' },
                { label: '已暂停', value: 'paused' },
                { label: '未激活', value: 'inactive' },
                { label: '已停用', value: 'suspended' },
              ]}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Auth配置ID" name="auth_config_id">
            <Input placeholder="可选" />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={[16, 0]}>
        <Col span={12}>
          <Form.Item label="运营人ID（逗号分隔）" name="operator_user_ids">
            <Input placeholder="例如：aispire,alice" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="运营人昵称（逗号分隔）" name="operator_user_names">
            <Input placeholder="例如：张三,李四" />
          </Form.Item>
        </Col>
      </Row>

      {drawerMode === 'create' && (
        <Form.Item noStyle shouldUpdate={(prev, cur) => prev.platform !== cur.platform}>
          {({ getFieldValue }) => {
            const p = String(getFieldValue('platform') || '').trim();
            if (!['抖音', '快手', '微信视频号'].includes(p)) return null;
            return (
              <Form.Item
                label="创建后扫码登录"
                name="login_after_create"
                valuePropName="checked"
                tooltip="在本机 Mac 上弹出二维码扫码登录，成功后自动上传 OSS 并回写账号配置"
              >
                <Switch defaultChecked />
              </Form.Item>
            );
          }}
        </Form.Item>
      )}

      {drawerMode === 'create' && (
        <Form.Item noStyle shouldUpdate={(prev, cur) => prev.platform !== cur.platform}>
          {({ getFieldValue }) => {
            const p = String(getFieldValue('platform') || '').trim();
            if (p !== '小红书') return null;
            return (
              <Form.Item
                label="小红书端口（可选，18060-18160）"
                name="xhs_prefer_port"
                tooltip="不填则自动分配端口；填了则尽量使用该端口（若被占用会失败）"
              >
                <InputNumber min={18060} max={18160} style={{ width: '100%' }} placeholder="例如：18063" />
              </Form.Item>
            );
          }}
        </Form.Item>
      )}

      <Form.Item label="平台配置（platform_config，JSON object）" name="platform_config">
        <Input.TextArea rows={10} placeholder='例如：{"douyin_cookie_file":"https://.../dy.json"}' />
      </Form.Item>
    </Form>
  </Drawer>
);

export default AccountEditorDrawer;
